import { useStats } from '../../../lib/ctx/stats'
import { useStatsPermission, useStatsZeroState } from '../../../lib/hooks'
import { ReaderInsight } from '../../shared/ReaderInsight'
import { StatsProfileBox } from '../../shared/stats_profile_box'
import pluralize from 'pluralize'
import { MomStreaksContent } from './MomStreaksContent'
import { getMonthName } from '../../../lib/utils'
import { analytics } from 'segment_analytics'

export const MomStreaks = () => {
  const [stats, yearStatus, streakMonth] = useStats((s) => [
    s.stats,
    s.yearStatus,
    s.streakMonth,
  ])
  const insight = stats?.streaks?.insight || ''
  const bestStreak = stats?.streaks?.best_streak?.count || 0
  const zeroState = useStatsZeroState('streaks')
  const { isStatsOwner } = useStatsPermission()
  const isPastYear = yearStatus === 'past'
  const id = 'monthly-streaks'

  const getFooter = () => {
    if (!isStatsOwner) return null

    if (zeroState && yearStatus === 'current') {
      return (
        <ReaderInsight
          data-testid={`reader-insight-${id}`}
          label="How to get started"
          text="Add books to your Currently Reading list, then start a reading streak
        by tapping “I read today” on the For You feed."
        />
      )
    }

    if (!isPastYear && !!insight?.length) {
      return (
        <ReaderInsight data-testid={`stats-insight-${id}`} text={insight} />
      )
    }
  }

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      text={{
        top: 'Best reading streak',
        main: bestStreak.toString(),
        unit: pluralize('day', bestStreak),
        infoText: (
          <>
            Add books to your Currently Reading list, then start a reading
            streak by tapping “I read today” on the For You feed.
            <br />
            <br />
            Note that due to privacy concerns, we only show other users what
            books you read if your Finished list is set to public.
          </>
        ),
      }}
      footer={getFooter()}
      screenshot={{
        enabled: !zeroState,
        component: <MomStreaksContent skipAnim hideMonthTabs />,
        text: {
          top: 'Best reading streak',
          main: getMonthName(streakMonth),
          hideBottomLabel: true,
        },
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'streaks' }),
      }}
    >
      {zeroState ? null : <MomStreaksContent />}
    </StatsProfileBox>
  )
}
